import React, { PureComponent } from "react";
import { connect } from "react-redux";
import OfferTypeSwitcher from "../components/OfferTypeSwitcher";
import { resetFilters } from "../actions/filter";
import { resetCollapsibles } from "../actions/componentStatus/collapsibles";
import { resetSorts } from "../actions/sort";
import { switchOfferType } from "../actions/offerType";
import { resetModal } from "../actions/modal";
import { resetOfferResultsPagination } from "../actions/componentStatus/offerResultsPagination";
import { OFFER_TYPES } from "../constants/offerTypes";
import { invalidateSponsoredPositions } from "../actions/portalData/sponsoredPositionData";
import { resetHasChangedFilters } from "../actions/componentStatus/hasChangedFilters";

class OfferTypeSwitcherContainer extends PureComponent {
  render() {
    const {
      clientConfig,
      offerType,
      onPhoneOfferClick,
      onPropositionClick,
      onSimOnlyClick
    } = this.props;

    return (
      <OfferTypeSwitcher
        clientConfig={clientConfig}
        offerType={offerType}
        onPhoneOfferClick={onPhoneOfferClick}
        onPropositionClick={onPropositionClick}
        onSimOnlyClick={onSimOnlyClick}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    clientConfig: state.clientConfig,
    offerType: state.offerType
  };
}

function mapDispatchToProps(dispatch) {
  return {
    invalidateSponsoredPositions: () => {
      dispatch(invalidateSponsoredPositions());
    },
    resetCollapsibles: () => {
      dispatch(resetCollapsibles());
    },
    resetFilters: clientConfig => {
      dispatch(resetFilters(clientConfig));
    },
    resetHasChangedFilters: () => {
      dispatch(resetHasChangedFilters());
    },
    resetModal: () => {
      dispatch(resetModal());
    },
    resetOfferResultsPagination: () => {
      dispatch(resetOfferResultsPagination());
    },
    resetSorts: clientConfig => {
      dispatch(resetSorts(clientConfig));
    },
    switchOfferType: offerType => {
      dispatch(switchOfferType(offerType));
    }
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const {
    invalidateSponsoredPositions,
    resetCollapsibles,
    resetFilters,
    resetHasChangedFilters,
    resetModal,
    resetOfferResultsPagination,
    resetSorts,
    switchOfferType
  } = dispatchProps;
  const { clientConfig } = stateProps;

  function onPhoneOfferClick() {
    switchOfferType(OFFER_TYPES.phoneOffer);
    invalidateSponsoredPositions();
    resetCollapsibles();
    resetFilters(clientConfig);
    resetHasChangedFilters();
    resetModal();
    resetOfferResultsPagination();
    resetSorts(clientConfig);
  }

  function onPropositionClick() {
    switchOfferType(OFFER_TYPES.proposition);
    invalidateSponsoredPositions();
    resetCollapsibles();
    resetFilters(clientConfig);
    resetHasChangedFilters();
    resetModal();
    resetOfferResultsPagination();
    resetSorts(clientConfig);
  }

  function onSimOnlyClick() {
    switchOfferType(OFFER_TYPES.simOnly);
    invalidateSponsoredPositions();
    resetCollapsibles();
    resetFilters(clientConfig);
    resetHasChangedFilters();
    resetModal();
    resetOfferResultsPagination();
    resetSorts(clientConfig);
  }

  return {
    ...stateProps,
    onPhoneOfferClick: () => onPhoneOfferClick(),
    onPropositionClick: () => onPropositionClick(),
    onSimOnlyClick: () => onSimOnlyClick()
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(OfferTypeSwitcherContainer);
